import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerFieldIdAtom} from "./routerStore";
import {activeCompanyFieldsAtom} from "./activeCompanyFieldsStore";
import {Field} from "../types/domain/field";

export const activeFieldAtom = atomWithRefresh<Promise<Field | undefined>>(async (get) => {
    const activeFieldId = get(routerFieldIdAtom);
    const fields = await get(activeCompanyFieldsAtom);

    return activeFieldId ? fields.mapByFieldId[activeFieldId] : undefined;
});
activeFieldAtom.debugLabel = "activeField";

export const activeFieldLoadable = loadable(activeFieldAtom);
